import React from 'react';

import StyledStatus from './styles';

const Status: React.FC<{ color: string }> = ({ color }) => (
  <StyledStatus color={color} />
);

export default Status;
